import type { Account, ApiAccount } from './accounts.types';

export const mapAccount = (apiAccount: ApiAccount): Account => apiAccount;

export const mapAccountToApi = (account: Account): ApiAccount => account;
